(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderCruiseDays',
	};

	var $modal = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.fit-builder-replace-cruise-image').click(function _showImageSelector(e) {
			var date          = $(this).data('date'),
				component_id  = $(this).data('component-id'),
				existing_image = $(this).data('existing-image');
			e.preventDefault();
			
			$modal.addClass('wide');
			$modal.find('.modal-title').text('Picture Tool');
			$modal.find('.modal-body').text('Loading picture tool...');

			Adzuki.Ajax.get('/FitBuilders/cruiseDayPicture/' + date + '/' + component_id + '/' + encodeURIComponent(existing_image))
			.then(function _showCruiseDayModal(html) {
				$modal.find('.modal-body').html(html);

				Adzuki.Form.initAjaxForm('FitBuilderCruiseDayImage');
				
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});
	};
}(jQuery, window.Adzuki || {}));